import React, { useState } from 'react';
import RegisterMutation from 'mutations/user/create';
import RegisterForm from 'components/user/authorization/register_form';
import { useLocale } from 'contexts/locale';
import { useError } from 'contexts/error';
import { Grid, Stack, Alert } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import {
  CardOptionTypography,
  CardOptionDescriptionTypography,
} from 'components/styles_components/typography';
import { DividerContainer, SectionGrid } from 'components/styles_components/container';

const Register = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const setError = useError();
  const { locale } = useLocale();
  const [registerMutation, { loading }] = useMutation(RegisterMutation, {
    onCompleted: () => {
      setShowSuccess(true);
    },
    onError: () => {
      setError('error.user.register');
    },
  });

  return (
    <Stack>
      <CardOptionTypography variant="h5" align="left">
        <FormattedMessage id="header.user.register" />
      </CardOptionTypography>
      <CardOptionDescriptionTypography>
        <FormattedMessage id="auth.register.description" />
      </CardOptionDescriptionTypography>
      <DividerContainer />
      <Grid container direction="row" justifyContent="center" alignItems="center">
        <RegisterForm
          initialValues={{
            email: '',
            password: '',
            termsAccepted: false,
            privacyPolicyAccepted: false,
            locale,
          }}
          onSubmit={(values) => registerMutation({ variables: values })}
          processing={loading || showSuccess}
        >
          {showSuccess && (
            <SectionGrid>
              <Alert severity="success" variant="filled">
                <FormattedMessage id="info.user.register.success" />
              </Alert>
            </SectionGrid>
          )}
        </RegisterForm>
      </Grid>
    </Stack>
  );
};

export default Register;
